export function fmtNum(n: number): string {
  if (n >= 100000000) {
    const v = n / 100000000;
    return `${(Math.round(v * 100) / 100).toString()}亿`;
  }
  if (n >= 10000) {
    const v = n / 10000;
    return `${(Math.round(v * 10) / 10).toString()}万`;
  }
  return n.toString();
}

export function tagClass(tag: string): string {
  const map: Record<string, string> = {
    反转盘点: 'bg-primary-100 text-primary-800 border-primary-200',
    录音流出: 'bg-accent-100 text-accent-800 border-accent-300/60',
    聊天记录: 'bg-secondary-100 text-secondary-800 border-secondary-200',
    当事人回应: 'bg-primary-50 text-primary-700 border-primary-200',
    打脸现场: 'bg-accent-50 text-accent-700 border-accent-300',
    证据梳理: 'bg-background-100 text-foreground-700 border-background-200',
  };
  return map[tag] || 'bg-background-100 text-foreground-700 border-background-200';
}

export function canonicalUrl(): string {
  const base = typeof __BASE_PATH__ === 'string' && __BASE_PATH__ ? __BASE_PATH__ : '/';
  const clean = base.endsWith('/') ? base.slice(0, -1) : base;
  const path = window.location.pathname.replace(new RegExp(`^${clean.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}`), '') || '/';
  return `${window.location.origin}${path}`;
}

declare const __BASE_PATH__: string;